import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NavWidgetComponentNew } from './components/nav-widget/nav-widget.component';
import { SearchWidgetComponent } from './components/search-widget/search-widget.component';
import { WidgetInsuranceWebComponent } from './widget-insurance-web.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WidgetModule } from '../../web/components/widget/widget.module';
/* Material */
import { MatSelectModule, MatInputModule, MatButtonModule } from '@angular/material';
import { RouterModule } from '@angular/router';
import { ToursWidgetComponent } from './components/tours-widget/tours-widget.component';
import { PaqueteWidgetComponent } from './components/paquete-widget/paquete-widget.component';
import { VuelosWidgetComponent } from './components/vuelos-widget/vuelos-widget.component';
import { HotelesWidgetComponent } from './components/hoteles-widget/hoteles-widget.component';
import { DestFlightComponent } from './components/paquete-widget/components/dest-flight/dest-flight.component';
import { OriginFlightComponent } from './components/paquete-widget/components/origin-flight/origin-flight/origin-flight.component';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { NavWidgetMobileComponent } from './components/nav-widget-mobile/nav-widget-mobile.component';
//import { WidgetDeviceComponent } from '../../web/components/widget/components/widget-device/widget-device.component';

@NgModule({
  declarations: [
    // NavWidgetComponentNew,
    // SearchWidgetComponent,
    //WidgetDeviceComponent,
    WidgetInsuranceWebComponent,
    OriginFlightComponent,
    NavWidgetMobileComponent,
    // VuelosWidgetComponent,
    
    // ToursWidgetComponent
  ],
  imports: [
    /**
     * Material
     */
    RouterModule,
    WidgetModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule
    
    
    
  ],
  exports: [
    // NavWidgetComponentNew,
    SearchWidgetComponent,
    WidgetInsuranceWebComponent,
    //WidgetDeviceComponent,
    /**
     * Material
     */
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    DestFlightComponent
  ]
})

export class WidgetInsuranceWebModule {}